<template>
  <div class="auth-form">
    <q-form @submit="handleLogin" class="q-gutter-md">
      <q-input
        v-model="credentials.email"
        label="Email"
        type="email"
        outlined
        dense
        required
      />
      <q-input
        v-model="credentials.password"
        label="Password"
        type="password"
        outlined
        dense
        required
      />
      <div class="row justify-end q-mt-md">
        <q-btn 
          type="submit" 
          color="primary" 
          label="Ingresar" 
          :loading="authStore.loading"
          unelevated
        />
      </div>
      <div v-if="authStore.error" class="text-negative text-caption q-mt-sm">
        {{ authStore.error }}
      </div>
    </q-form>
  </div>
</template>

<script setup>
import { reactive } from 'vue';
import { useAuthStore } from '/src/stores/useAuthStore.js';

const authStore = useAuthStore();
const credentials = reactive({
  email: '',
  password: ''
});

const emit = defineEmits(['success']);

async function handleLogin() {
  const success = await authStore.login(credentials);
  if (success) {
    emit('success');
  }
}
</script>

<style scoped>
.auth-form {
  padding: 16px;
}
</style>
